import React from 'react';

export interface HeroProps {
  background: string;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  /** First marketing band uses header; later bands use section. */
  as?: 'header' | 'section' | 'div';
}

const Hero = ({
  background,
  children = null,
  className = '',
  style = undefined,
  as: Tag = 'section',
}: HeroProps) => {
  const backgroundImage = background && `url(${background}) no-repeat`;

  return (
    <Tag
      className={className}
      style={{ background: backgroundImage, backgroundSize: 'cover', ...style }}
    >
      {children}
    </Tag>
  );
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.tsx